import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WindowFormService {
  private openedWindowRef: Window | null = null;

  openWindow(url: string, target: string = '_blank') {
    if (!this.openedWindowRef || this.openedWindowRef.closed) {
      this.openedWindowRef = window.open(url, target) || null;
    } else {
      try {
        this.openedWindowRef.location.href = url;
        this.openedWindowRef.focus();
      } catch {
        this.openedWindowRef = window.open(url, target) || null;
      }
    }
  }

  openPostForm(url: string, data: Record<string, any>, target: string = '_blank') {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = target;

    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value ?? '');
      form.appendChild(input);
    });

    document.body.appendChild(form);
    // Ensure popup target exists for some browsers’ blockers
    // if (target === '_blank') window.open('', target);
    form.submit();
    document.body.removeChild(form);
  }
}